
import { of as observableOf,  Observable } from 'rxjs';
import { catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { IEventCustomFields, IUpdateCustomEventFields } from './eventcustomfields-model';

@Injectable()
export class EventCustomFieldsService {

  constructor(private http: HttpClient) { }

  private static get URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${EventCustomFieldsService.ENDPOINT}`; }
  private static readonly ENDPOINT = 'eventcustomfields';

  public getEventCustomFields(): Observable<SuccessResponse<IEventCustomFields> | ErrorResponse> {
    return this.http
    .get<SuccessResponse<IEventCustomFields>>(EventCustomFieldsService.URL).pipe(
    catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

  public updateEventCustomFields(submitData: IUpdateCustomEventFields): Observable<SuccessResponse<boolean> | ErrorResponse> {
    return this.http
    .put<SuccessResponse<boolean>>(EventCustomFieldsService.URL, submitData).pipe(
      catchError(x => observableOf(new ErrorResponse(x?.error?.messages))));
  }

}
